<template>
  <div class="client_info__container form error">
    <div v-if="doNotDeliver" class="error-delivery">{{ deliveryError }}</div>
    <div v-else-if="deliveryCheckFailed" class="error-delivery" role="alert">
      {{ $t('reschedule.change-address.check-unavailable') }}
      <button type="button" class="btn outline" @click="retryDeliveryCheck">{{ $t('reschedule.change-address.retry-check') }}</button>
    </div>
    <c-address-full
      v-model:address="computedAddress"
      :error="doNotDeliver"
      :origin="orderData.recipient.address"
      :placeholder="$t('plain.start-typing')"
      :label="$t('plain.full-address')"
      small-label
    ></c-address-full>
    <c-input v-model="computedAddress.address" :error="doNotDeliver" :label="$t('plain.street-address')" small-label></c-input>
    <c-input
      v-model="computedAddress.zip"
      :error="doNotDeliver"
      :label="$t('plain.zip')"
      small
      small-label
    ></c-input>
    <c-input
      v-model="computedAddress.city"
      :error="doNotDeliver"
      :label="$t('plain.city')"
      small
      small-label
    ></c-input>
    <c-address-state
      v-model="computedAddress.state"
      :address="computedAddress"
      :error="doNotDeliver"
      :label="$t('plain.state')"
      small
      small-label
    ></c-address-state>
    <c-input
      v-model="computedAddress.apt"
      :error="doNotDeliver"
      :label="$t('plain.apt')"
      small
      small-label
    ></c-input>

    <c-map v-model:address="computedAddress" :facility-geo="orderData.facility.geo"></c-map>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import CInput from '@/components/UI/form/c-input.vue'
import { useTypes } from '@/compositions/Address'
import { isRx4Route } from '@/config'
import { deliveryAreaDenied, deliveryFacilityName } from '@/utils/trackingDeliveryArea.mjs'
import CMap from './address/c-map.vue'
import CAddressState from './address/c-address-state.vue'
import CAddressFull from './address/c-address-full.vue'

export default {
  name: 'change-address',
  components: {
    CMap,
    CInput,
    CAddressState,
    CAddressFull,
  },
  setup() {
    return useTypes()
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters(['rescheduleData', 'orderData']),
    computedAddress: {
      get() {
        this.defineAddress()
        return this.rescheduleData.address
      },
      set(address) { this.rescheduleData.address = address },
    },
    doNotDeliver() {
      return deliveryAreaDenied(this.orderData, this.types, this.rescheduleData.order_type, isRx4Route)
    },
    deliveryCheckFailed() {
      return isRx4Route && this.deliveryCheck.failed
    },
    deliveryError() {
      return isRx4Route
        ? this.$t('reschedule.change-address.outside-service-area', { facility: deliveryFacilityName(this.orderData) })
        : this.$t('reschedule.change-address.error')
    },
  },
  methods: {
    defineAddress() {
      if (!('address' in this.rescheduleData)) {
        this.rescheduleData.address = { ...JSON.parse(JSON.stringify(this.orderData.recipient.address)) }
      }
    },
  },
}
</script>
<style>
.error-delivery {
  font-weight: bold;
  font-size: 23px;
  color: var(--color-error);
}
</style>
